import React, { useEffect, useState } from "react";
import TextInput from "../FormItems/TextInput.jsx";
import GeneralError from "../FormItems/GeneralError.jsx";
import SelectInput from "../FormItems/SelectInput.jsx";
import fetchStates from "../FindOfficeForm/fetchOptions.js";

const AgencyVerificationForm = (props) => {
  const {
    label,
    submitLabel,
    city,
    agencyName,
    stateSelect,
    zipCode,
    serviceState,
    formAction = "",
    method = "post",
    errorMessage,
  } = props;

  const [stateOptions, setStateOptions] = useState([]);
  const [serviceStateOptions, setServiceStateOptions] = useState([]);
  const [loadingStates, setLoadingStates] = useState(false);
  const [statesError, setStatesError] = useState(null);

  const propOptions = Array.isArray(stateSelect?.options) ? stateSelect.options : [];

  useEffect(() => {
    const ac = new AbortController();
    setLoadingStates(true);
    setStatesError(null);

    fetchStates({ signal: ac.signal, params: { sheet: "states" } })
      .then((data) => {
        const fetched = Array.isArray(data?.options) ? data.options : [];
        setStateOptions(fetched.length ? fetched : propOptions);
        setServiceStateOptions(fetched.length ? fetched : propOptions);
      })
      .catch(() => {
        setStateOptions(propOptions);
        setServiceStateOptions(propOptions);
        setStatesError("Unable to load states.");
      })
      .finally(() => setLoadingStates(false));

    return () => ac.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <form
      className="sc-form js-form find-office-form"
      data-form-type="agencyVerification"
      action={formAction}
      method={method}
      onSubmit={handleSubmit}
      data-pagination-target="#office-pagination"
    >
      {label && <h2 className="sc-form__title">{label}</h2>}

      <div className="find-office-form__inputs-container">
        <div>
          <TextInput
            {...agencyName}
            name="agencyname"
            placeholder={agencyName?.placeholder ?? "Agency Name"}
          />
        </div>
        <div>
          <TextInput
            {...city}
            name="city"
            placeholder={city?.placeholder ?? "City"}
          />
        </div>
      </div>

      <div className="find-office-form__selects-container">
        <div className="find-office-form__select">
          <SelectInput
            {...stateSelect}
            options={stateOptions || []}
            label=""
            placeholder={
              loadingStates
                ? "Loading states…"
                : stateSelect?.placeholder ?? "Select a State"
            }
            name="state-select"
            disabled={loadingStates || !!statesError}
          />
        </div>

        <div className="find-office-form__select">
          <TextInput {...zipCode} name="zip" placeholder="Zip Code" />
        </div>
      </div>

      <SelectInput
        {...serviceState}
        options={serviceStateOptions || []}
        label=""
        placeholder={serviceState?.placeholder ?? "Select a Service State"}
        name="serviceState"
      />

      <GeneralError />

      <div className="sc-form__button-row">
        <input type="submit" className="btn btn--primary" value={submitLabel} />
      </div>

      {errorMessage && (
        <div className="find-office-form__message">{errorMessage}</div>
      )}
    </form>
  );
};

export default AgencyVerificationForm;
